import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Radio, withStyles } from "@material-ui/core";
import PaginadorApp from "app/Core/Components/Paginador/PaginadorApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaCategoriaActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class EmpresaCategoriaList extends XAPPComponent {

    state = {
        selected: []
    };

    componentDidMount() {
        const { listFilter } = this.props;
        listFilter(null, "spvwempresacategoria");
    }

    componentDidUpdate() {
        if (this.props.Categoria.error) {
            this.props.showMessage({
                message: this.props.Categoria.error,
                variant: "error"
            });
            this.props.Categoria.error = null;
        }
    }

    handleChangeRadio = (event, item) => {
        var AState = this.state.selected;
        var AExists = false;
        if (this.isSelected(item.idpessoaformulario))
            AExists = true;

        if (!AExists) {
            var obj = item;
            obj["id"] = item.idpessoaformulario;
            obj["label"] = item.nome;
            if (!this.props.multiSelect)
                AState = [];
            AState.push(obj);
            this.setState(_.set({ ...this.state }, event.target.name, AState));
            this.props.onChange(AState);
        }
    };

    isSelected = (id) => {
        var AState = this.state.selected;
        var AExists = false;
        AState.forEach((item) => {
            if (item.idpessoaformulario === id || item.id === id)
                AExists = true;
        });
        return AExists;
    };

    getColumns = (_AisLookup) => {
        const { isLookup } = this.props;
        const { selected } = this.state;
        const Columns = [
            {
                Header: "",
                width: 60,
                Cell: row => (
                    <div className="flex items-center">
                        {isLookup && row.original.statusregistro === 1 && (
                            <Radio
                                name="selected"
                                checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                onClick={event => event.stopPropagation()}
                                onChange={event => this.handleChangeRadio(event, row.original)}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: "",
                accessor: "codigo",
                Cell: row => (
                    <div
                        className="flex items-center"
                        style={{
                            width: "100%",
                            height: "100%",
                            textIndent: row.original.codigo.split(".").length * 25,
                        }}
                    >
                        {row.original.codigo + " - " + row.original.nome}
                    </div>
                )
            }
        ];

        if (_AisLookup !== true) {
            Columns.splice(0, 1);
        }
        return Columns;
    };

    nextPage = () => {
        const { filter, xappRouteParams, Categoria } = this.props;
        if (Categoria.pagina < Categoria.data[0].paginas) {
            this.props.list("SELECIONAR", xappRouteParams, filter, Categoria.pagina + 1);
        }
    };

    render() {
        const { Categoria, openEditDialog, classes, isLookup } = this.props;

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    className={classNames(classes.root, "-striped -highlight border-0")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            className: rowInfo && rowInfo.original.codigo.split(".").length > 1 && "cursor-pointer",
                            onClick: () => {
                                if (rowInfo && rowInfo.original.codigo.split(".").length > 1) {
                                    openEditDialog(rowInfo.original);
                                }
                            }
                        };
                    }}
                    data={Categoria.data ? Categoria.data : []}
                    columns={this.getColumns(isLookup)}
                    defaultPageSize={100}
                    PaginationComponent={PaginadorApp}
                    nextPage={this.nextPage}
                    paginas={Categoria.data ? Categoria.data[0].paginas : 1}
                    pagina={Categoria.pagina}
                    noDataText="Não existem registros cadastrados!"
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        openNewDialog: Actions.openNewDialog,
        openEditDialog: Actions.openEditDialog,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaCategoria }) {
    return {
        Categoria: EmpresaCategoria
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaCategoriaList)));
